import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import { ApplicationType } from "@libs/api/gateways/plt/plt-gateway.dtos";

import { TenantFilterValues } from "./tenants-filter.types";

export const useTenantsFilterSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const initialValues: TenantFilterValues = useMemo(() => {
    const name = searchParams.get("name") ?? "";
    const tenantId = searchParams.get("tenantId") ?? "";
    const crmId = searchParams.get("crmId") ?? "";
    const selfAssertedCrmId = searchParams.get("selfAssertedCrmId") ?? "";
    const applications = (searchParams.getAll("applications") ??
      []) as ApplicationType[];

    const isInactive = (searchParams.get("isInactive") ?? false) as boolean;

    return {
      name,
      tenantId,
      crmId,
      selfAssertedCrmId,
      isInactive,
      applications
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { initialValues, setSearchParams };
};
